module.exports = __webpack_public_path__ + "static/media/logo_producto.31537979.png";